import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic2, Crown, Vote, Trophy, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

/**
 * Section page d'accueil : promotion du concept MBOAZICK Talent
 * (visible que l'on ait ou non une édition en cours).
 */
export default function TalentHomeSection() {
    const [edition, setEdition] = useState(null);
    useEffect(() => {
        api.get("/talent/current").then(({ data }) => setEdition(data?.edition || null)).catch(() => {});
    }, []);

    return (
        <section className="border-t border-[#1c1c1c] bg-[#080604]" data-testid="talent-home-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-center">
                    {/* Left — concept */}
                    <div className="lg:col-span-3">
                        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37] flex items-center gap-2">
                            <Mic2 className="w-4 h-4" /> Programme phare
                        </p>
                        <h2 className="mt-3 font-display text-3xl md:text-5xl font-semibold tracking-tight leading-[1.05]">
                            MBOAZICK <span className="text-[#D4AF37]">Talent</span>
                            <br />
                            <span className="text-[#F4F4F4]">Le freestyle challenge</span> panafricain.
                        </h2>
                        <p className="mt-5 text-[#C8C8C8] leading-relaxed max-w-xl text-sm md:text-base">
                            Un instrumental officiel. Une performance. Un classement mixte
                            <strong className="text-[#F4F4F4]"> 60 % public + 40 % jury</strong>.
                            Cash, équipement, visibilité — MBOAZICK Talent révèle la nouvelle vague
                            des artistes africains, sans piston.
                        </p>

                        <div className="mt-8 flex flex-wrap items-center gap-4">
                            <Link to="/talent/concept" className="group inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#e6c14d] text-[#0F0F0F] font-bold px-7 py-3.5 rounded-full transition-all" data-testid="talent-home-cta-concept">
                                Découvrir le concept <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                            </Link>
                            {edition && (
                                <Link to="/talent" className="inline-flex items-center gap-2 border border-[#00d97e]/50 hover:bg-[#00d97e]/10 text-[#00d97e] font-semibold px-6 py-3.5 rounded-full transition-colors" data-testid="talent-home-cta-active">
                                    <span className="w-2 h-2 rounded-full bg-[#00d97e] animate-pulse" />
                                    Édition en cours
                                </Link>
                            )}
                        </div>
                    </div>

                    {/* Right — 3 highlights + CTA */}
                    <div className="lg:col-span-2 space-y-3">
                        <Highlight
                            icon={<Mic2 className="w-5 h-5" />}
                            accent="#00d97e"
                            title="Un instrumental officiel"
                            text="Même terrain pour tous : le beat commun de l'édition."
                        />
                        <Highlight
                            icon={<Vote className="w-5 h-5" />}
                            accent="#00c0ff"
                            title="Classement 60 / 40"
                            text="Votes publics + jury professionnel indépendant."
                        />
                        <Highlight
                            icon={<Crown className="w-5 h-5" />}
                            accent="#c084fc"
                            title="Hall of Fame"
                            text="Le champion de chaque édition entre dans la légende."
                        />
                        <Highlight
                            icon={<Trophy className="w-5 h-5" />}
                            accent="#D4AF37"
                            title="5 trophées spéciaux"
                            text="Public · Jury · Révélation · Performance · Plume."
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

function Highlight({ icon, accent, title, text }) {
    return (
        <div className="flex items-start gap-4 bg-[#0d0d0d] border rounded-2xl p-4 hover:-translate-y-0.5 transition-transform" style={{ borderColor: `${accent}33` }}>
            <div className="w-11 h-11 rounded-full flex items-center justify-center border shrink-0" style={{ background: `${accent}15`, borderColor: `${accent}55`, color: accent }}>
                {icon}
            </div>
            <div className="min-w-0">
                <p className="font-semibold text-sm">{title}</p>
                <p className="mt-0.5 text-xs text-[#A8A8A8] leading-relaxed">{text}</p>
            </div>
        </div>
    );
}
